// Investiture
import React from 'react';
import KannadaCCA3to52025 from '../views/KannadaCCA3to52025';


const InvestiturePage = () => {
  return <KannadaCCA3to52025 />;
};

export default InvestiturePage;
